import { TSetContactAttributesBody } from '@cloud-wave/neon-common-lib';

import { LogEvents, logger } from 'lib/common/components/LoggerController';

interface ISetContactAttributesParams {
  contactId: string;
  attributes: Array<{
    key: string;
    value: string;
  }>;
  fetch_: (url: string, options?: RequestInit) => Promise<Response>;
  agentServiceUrl: string;
}

export default async function setContactAttributes({
  contactId,
  attributes,
  fetch_,
  agentServiceUrl,
}: ISetContactAttributesParams): Promise<void> {
  try {
    const contactAttributes: TSetContactAttributesBody = {
      attributes,
    };

    await fetch_(`${agentServiceUrl}/contact/${contactId}/contact-attributes`, {
      method: 'PATCH',
      body: JSON.stringify(contactAttributes),
    });

    logger.info(LogEvents.TASK.CONTACT_ATTRIBUTE_SET.SUCCESS, {
      contactId,
      attributes,
      action: 'SET_CONTACT_ATTRIBUTES',
    });
  } catch (error) {
    logger.error(LogEvents.TASK.CONTACT_ATTRIBUTE_SET.FAIL, {
      contactId,
      attributes,
      error,
      action: 'SET_CONTACT_ATTRIBUTES',
    });
    throw error;
  }
}
